import { motion } from 'framer-motion';
import React, { useState } from 'react';

export const SprintIcon: React.FC = () => {
	const [hovered, setHovered] = useState(false);
	return (
		<svg
			width="85"
			height="70"
			viewBox="0 0 85 70"
			fill="none"
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<motion.path
				d="M55 61.373C61.1186 58.3889 66.4568 53.0354 69.2514 47.3181L77 47.318V44L83.2313 54.5L77 65V61.373L55 61.373Z"
				stroke="#F27C00"
				strokeWidth="1.5"
				animate={hovered ? { fillOpacity: 1 } : { fillOpacity: 0 }}
				transition={{ duration: 0.3 }}
				fill="#F27C00"
			/>
			<motion.path
				d="M16.2647 37.355L8.65242 32.6765H9.02875H9.81173L9.77806 31.8942C9.75942 31.4613 9.75 31.0259 9.75 30.5882C9.75 14.109 23.109 0.75 39.5882 0.75C56.0674 0.75 69.4265 14.109 69.4265 30.5882C69.4265 47.0675 56.0674 60.4265 39.5882 60.4265H0.75V48.1618H39.5882C49.2938 48.1618 57.1618 40.2938 57.1618 30.5882C57.1618 20.8826 49.2938 13.0147 39.5882 13.0147C29.8826 13.0147 22.0147 20.8826 22.0147 30.5882C22.0147 31.0583 22.0332 31.5242 22.0695 31.9853L22.1239 32.6765H22.8172H23.877L16.2647 37.355Z"
				stroke="#F27C00"
				strokeWidth="1.5"
				animate={hovered ? { fillOpacity: 1 } : { fillOpacity: 0 }}
				transition={{ duration: 0.3 }}
				fill="#F27C00"
			/>
		</svg>
	);
};
